import React, { FC } from 'react'

import DefaultLayout, { DefaultLayoutProps } from '../../../layouts/DefaultLayout'
import ForgotPasswordForm, {
  ForgotPasswordFormProps,
} from '../../../components/forms/PasswordForm/ForgotPasswordForm'
import * as SC from '../styled'

export type ForgotPasswordTemplateProps = {
  className?: string
  layout?: DefaultLayoutProps
  forgotPasswordForm: ForgotPasswordFormProps
}

const ForgotPasswordTemplate: FC<ForgotPasswordTemplateProps> = (props) => {
  const { layout, forgotPasswordForm } = props

  return (
    <DefaultLayout {...layout}>
      <SC.Content>
        <ForgotPasswordForm {...forgotPasswordForm} />
      </SC.Content>
    </DefaultLayout>
  )
}

export default ForgotPasswordTemplate
